import { InsuranceProvider } from '@nemuru-eng/js-api-client/slim';
import React from 'react';

interface InsuranceProviderLogoProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  insuranceProvider: InsuranceProvider;
  size?: number;
}

export const InsuranceProviderLogo = ({ insuranceProvider, size = 24, ...props }: InsuranceProviderLogoProps) => {
  const logo = getInsuranceProviderLogo(insuranceProvider);
  return (
    <img
      src={`https://cdn.nemuru.com/assets/logos/letterform/${logo}`}
      alt={`${insuranceProvider} logo`}
      {...props}
      style={{ ...props.style, height: size, width: 'auto' }}
    />
  );
};

const getInsuranceProviderLogo = (insuranceProvider: InsuranceProvider) => {
  if (insuranceProvider === InsuranceProvider.BBVA) return 'bbva-logo.svg';
  if (insuranceProvider === InsuranceProvider.CAIXABANK) return 'caixabank-logo.svg';
  if (insuranceProvider === InsuranceProvider.SANTANDER_CONSUMER) return 'santander_consumer-logo.svg';
  if (insuranceProvider === InsuranceProvider.BS) return 'bs-logo.svg';
  if (insuranceProvider === InsuranceProvider.SOYOU) return 'soyou-logo.svg';
  if (insuranceProvider === InsuranceProvider.ABANCA) return 'abanca-logo.svg';
  if (insuranceProvider === InsuranceProvider.COFIDIS) return 'cofidis-logo.svg';
  if (insuranceProvider === InsuranceProvider.WEE_COVER) return 'wee_cover-logo.svg';
  throw new Error(`[InsuranceProviderLogo.getInsuranceProviderLogo] Unknown insurance provider: ${insuranceProvider}`);
};
